module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon03.68d494a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon03.png
// module id = hH5I
// module chunks = 0